export default __webpack_public_path__ + "static/media/phonegirl.5ac56947.png";